import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExtractService {
  /**
   * Lê o payload de um JWT sem validar a assinatura — quem valida é a API, a cada
   * chamada. Aqui só se quer saber se o token tem a forma de um token e o que ele
   * carrega.
   *
   * Lança quando o valor não é um JWT (sem o segundo segmento, ou com base64
   * inválido). Quem chama precisa tratar isso.
   */
  getDecodedAccessToken(token: string): any {
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(''),
      );

      return JSON.parse(jsonPayload);
    }
  }
}
